import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import {UAParser} from 'ua-parser-js';
import { Observable } from 'rxjs';
import { AnalyticsData, DeviceInformation, LocationInfo } from '../Models/Session';
@Injectable({
  providedIn: 'root'
})
export class AnalyticsServiceService {
  constructor(private Api: BaseApiService)
  {

  }

onSubmitLinks(username:string,linktype:string,link:string,clickType:string): void {
  let item         = this.getDeviceInformation();
  let browser      = this.parseUserAgent(this.getDeviceInformation());
  this.getDeviceLocation().subscribe(location=>{
    const data: AnalyticsData = {
      username  : username,
      linkType  : linktype,
      link      : link,
      browser   : browser.browser.name,
      type      : browser.os.name,
      deviceName: item,
      long      : location.longitude.toString(),
      latitude  : location.latitude.toString(),
      clickType :clickType
    };
    this.Api.create("Analytics", data).subscribe
      (
        (response) =>
        {

        },
        (
          error
        ) =>
        {

        }
      )
  });

}

  getDeviceLocation(): Observable<LocationInfo> {
    return new Observable<any>((observer) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;
            observer.next({ latitude, longitude });
            observer.complete();
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED)
            {
              const defaultLatitude  = 48.8566;
              const defaultLongitude = 2.3522;
              observer.next({ latitude: defaultLatitude, longitude: defaultLongitude });
              observer.complete();
            }
            else
            {
               observer.error(error.message);
            }
          }
        );
      } else {
        observer.error('Geolocation is not supported by this browser.');
      }
    });
  }

  getDeviceInformation()
  {
     const userAgent  = navigator.userAgent;
     return userAgent;
  }

  private parseUserAgent(userAgent: string): DeviceInformation {
    const parser = new UAParser(userAgent);
    const result = parser.getResult();
    return {
      browser: {
        name: result.browser.name!,
        version: result.browser.version!
      },
      engine: {
        name: result.engine.name!,
        version: result.engine.version!
      },
      os: {
        name: result.os.name!,
        version: result.os.version!
      }
    };
  }

}
